import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const { } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section
        className="relative min-h-screen pt-28 pb-16 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Majestic%20view%20of%20the%20Prophets%20Mosque%20in%20Medina%20with%20iconic%20green%20dome%20and%20minarets%2C%20beautiful%20Islamic%20architecture%20at%20golden%20hour%2C%20pilgrims%20in%20courtyard%2C%20spiritual%20atmosphere%20with%20warm%20lighting%2C%20detailed%20architectural%20features%20of%20Masjid%20an-Nabawi%2C%20peaceful%20religious%20scene%20with%20elegant%20composition&width=1920&height=1080&seq=medina-hero&orientation=landscape')`
        }}
      >
        <div className="text-center text-white max-w-4xl mx-auto px-4 w-full">
          <div className="mb-6 md:mb-8 animate-fade-in-up">
            <img
              src="https://static.readdy.ai/image/3d693276a5424479ffa5f1cc868e7c58/99585d34dbb7c267061331244ebc5e82.png"
              alt="Rigland Travels"
              className="mx-auto mb-4 md:mb-6 h-20 md:h-32 w-auto drop-shadow-2xl"
            />
            <p className="text-base md:text-xl text-logo-gold-200 mb-6 md:mb-8 font-light tracking-wide px-2">
              Your Gateway to Sacred Journeys & Global Adventures
            </p>
          </div>
          
          
          {/* Journey Selection Cards */}
          <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto transition-all duration-1000 ease-out w-full ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
            {/* Hajj & Umrah Card */}
            <a
              href="/hajj-umrah"
              className="group bg-gradient-to-br from-[#5a4a38] to-[#2a2a2a] hover:from-[#6b5a48] hover:to-[#3a3a3a] p-8 rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-300 cursor-pointer border-2 border-[#7a6a58]"
            >
              <div className="text-center">
                <div className="w-20 h-20 bg-[#7a6a58]/40 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#7a6a58]/50 transition-colors">
                  <i className="ri-building-line text-4xl text-[#b8a080]"></i>
                </div>

                <h3 className="text-3xl font-bold text-[#b8a080] mb-6">
                  Hajj & Umrah
                </h3>

                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-map-pin-line mr-2"></i>
                    <span className="text-sm">Holy Sites</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-flight-takeoff-line mr-2"></i>
                    <span className="text-sm">Flights</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-hotel-line mr-2"></i>
                    <span className="text-sm">Hotels</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-taxi-line mr-2"></i>
                    <span className="text-sm">Transport</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-user-heart-line mr-2"></i>
                    <span className="text-sm">Guidance</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-shield-check-line mr-2"></i>
                    <span className="text-sm">Visa Support</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-restaurant-line mr-2"></i>
                    <span className="text-sm">Meals</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-customer-service-line mr-2"></i>
                    <span className="text-sm">24/7 Support</span>
                  </div>
                </div>

                <div className="bg-[#b8a080] text-gray-900 px-6 py-3 rounded-full font-bold text-2xl group-hover:bg-[#c8b090] transition-colors">
                  BOOK NOW
                </div>
              </div>
            </a>

            {/* General Destinations Card */}
            <Link
              to="/general"
              className="group bg-gradient-to-br from-[#2a2a2a] to-[#5a4a38] hover:from-[#3a3a3a] hover:to-[#6b5a48] p-8 rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-300 cursor-pointer border-2 border-[#7a6a58]"
            >
              <div className="text-center">
                <div className="w-20 h-20 bg-[#7a6a58]/40 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#7a6a58]/50 transition-colors">
                  <i className="ri-earth-line text-4xl text-[#b8a080]"></i>
                </div>

                <h3 className="text-3xl font-bold text-[#b8a080] mb-6">
                  General Destinations
                </h3>

                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-suitcase-line mr-2"></i>
                    <span className="text-sm">Vacations</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-hotel-line mr-2"></i>
                    <span className="text-sm">Hotels</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-flight-takeoff-line mr-2"></i>
                    <span className="text-sm">Flights</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-compass-line mr-2"></i>
                    <span className="text-sm">Activities</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-taxi-line mr-2"></i>
                    <span className="text-sm">Transport</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-shield-check-line mr-2"></i>
                    <span className="text-sm">Visa Support</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-restaurant-line mr-2"></i>
                    <span className="text-sm">Meals</span>
                  </div>
                  <div className="flex items-center justify-center text-[#b8a080]/90">
                    <i className="ri-customer-service-line mr-2"></i>
                    <span className="text-sm">24/7 Support</span>
                  </div>
                </div>

                <div className="bg-[#b8a080] text-gray-900 px-6 py-3 rounded-full font-bold text-2xl group-hover:bg-[#c8b090] transition-colors">
                  BOOK NOW
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-16 bg-gradient-to-r from-gray-900 to-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="text-stone-400">
              <div className="text-3xl font-bold text-stone-500 mb-2">50K+</div>
              <div className="text-stone-400">Hajj & Umrah Pilgrims</div>
            </div>
            <div className="text-stone-400">
              <div className="text-3xl font-bold text-stone-500 mb-2">200K+</div>
              <div className="text-stone-400">Happy Travelers</div>
            </div>
            <div className="text-stone-400">
              <div className="text-3xl font-bold text-stone-500 mb-2">150+</div>
              <div className="text-stone-400">Destinations</div>
            </div>
            <div className="text-stone-400">
              <div className="text-3xl font-bold text-stone-500 mb-2">24/7</div>
              <div className="text-stone-400">Customer Support</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
